export default {"src":"/_next/static/media/solid-yellow-checkmark.6d9b834a.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};